import React from "react";
import Lottie from "lottie-react";
import loader from "./animation.json";

const ProcessingAnimation = () => (
  <div
    style={{ background: "rgba(17,17,17,0.96)", top: 0, left: 0 }}
    className="full-width full-height position-absolute"
  >
    <Lottie
      animationData={loader}
      loop
      style={{
        width: "85%",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        margin: "40% auto",
      }}
    />
  </div>
);

export default ProcessingAnimation;
